// start:ng42.barrel
import './cca-custom-data.component';
// end:ng42.barrel

